// =======================
// RESPONSIVE FILTERS - Sync modal filters with responsive breakpoints
// =======================
document.addEventListener('DOMContentLoaded', function () {
    // Questo script gira su ogni pagina (bundle globale), ma le sezioni modali dei filtri
    // esistono solo nella pagina di ricerca/elenco annunci: esce subito altrove per evitare
    // query DOM inutili e warning in console.
    if (!document.getElementById('modalFilterBtn')) {
        return;
    }

    // Map filters to their breakpoints
    // The filter shows in main panel AT this breakpoint and above
    // The filter shows in modal BELOW this breakpoint
    const filterBreakpoints = [
        { 
            id: 'indirizzoFilter',
            mainBreakpoint: 'sm',      // Shows in main from sm+ (d-none d-sm-block)
            modalSection: 'modalIndirizzoFilterSection',
            modalClass: 'd-sm-none'    // Shows in modal below sm (hides at sm+)
        },
        { 
            id: 'categoryFilter',
            mainBreakpoint: 'md',      // Shows in main from md+ (d-none d-md-block)
            modalSection: 'modalCategoryFilterSection',
            modalClass: 'd-md-none'    // Shows in modal below md (hides at md+)
        },
        { 
            id: 'priceFilter',
            mainBreakpoint: 'lg',      // Shows in main from lg+ (d-none d-lg-block)
            modalSection: 'modalPriceFilterSection',
            modalClass: 'd-lg-none'    // Shows in modal below lg (hides at lg+)
        },
        { 
            id: 'surfaceFilter',
            mainBreakpoint: 'xl',      // Shows in main from xl+ (d-none d-xl-block)
            modalSection: 'modalSurfaceFilterSection',
            modalClass: 'd-xl-none'    // Shows in modal below xl (hides at xl+)
        },
        { 
            id: 'tribunaleFilter',
            mainBreakpoint: 'xxl',     // Shows in main from xxl+ (d-none d-xxl-block)
            modalSection: 'modalTribunaleFilterSection',
            modalClass: 'd-xxl-none'   // Shows in modal below xxl (hides at xxl+)
        }
    ];

    console.log('Initializing responsive filters with breakpoint-based visibility');

    // Apply the responsive classes to modal sections
    filterBreakpoints.forEach(filter => {
        const modalSection = document.getElementById(filter.modalSection);
        if (modalSection) {
            // Remove any existing d-none class
            modalSection.classList.remove('d-none');
            // Add the breakpoint-specific class
            modalSection.classList.add(filter.modalClass);
            console.log(`✓ Modal section ${filter.modalSection} configured with ${filter.modalClass}`);
        } else {
            console.warn(`Modal section not found: ${filter.modalSection}`);
        }
    });

    // Optional: Add badge count based on which filters are hidden at current viewport
    // This would require checking window width, but since Bootstrap handles visibility,
    // we can rely on CSS to show/hide the modal button itself

    // Function to count hidden filters and update badge
    function updateFilterBadge() {
        const modalBtn = document.getElementById('modalFilterBtn');
        if (!modalBtn) return;

        // Bootstrap breakpoints in pixels
        const breakpoints = {
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
            xxl: 1400
        };

        const currentWidth = window.innerWidth;
        let hiddenCount = 0;

        // Count how many filters are hidden based on current viewport
        filterBreakpoints.forEach(filter => {
            const breakpointPx = breakpoints[filter.mainBreakpoint];
            if (currentWidth < breakpointPx) {
                hiddenCount++;
            }
        });

        // Remove existing badge if present
        let badge = modalBtn.querySelector('.badge');

        if (hiddenCount > 0) {
            if (!badge) {
                badge = document.createElement('span');
                badge.className = 'badge bg-primary rounded-circle position-absolute top-0 start-100 translate-middle';
                badge.style.fontSize = '0.65rem';
                badge.style.padding = '0.35em 0.5em';
                modalBtn.style.position = 'relative';
                modalBtn.appendChild(badge);
            }
            badge.textContent = hiddenCount;
        } else {
            if (badge) {
                badge.remove();
            }
        }
    }

    // Update badge on load and resize
    updateFilterBadge();
    window.addEventListener('resize', updateFilterBadge);

    console.log('Responsive filters initialized - using Bootstrap breakpoint classes');
});
